<template>
  <div class="p-[16px]">
    <template v-if="!(loader || loader2 || loader3 || loader4)">
      <div class="mb-[16px] flex justify-between">
        <div>
          <h2 class="text-[18px] text-[#2b2b2b] font-light">Dashboard</h2>
          <h3 class="mt-1 text-[13px] font-extralight text-[#7b7a7a]">Bienvenue sur le tableau de bord ehr IUGB</h3>
        </div>
        <div class="grow flex items-center justify-end gap-x-[4px]">
          <button class="text-[#2b2b2b] rounded-lg h-[36px] flex gap-x-[6px] items-center border px-6 font-light">
            <LayoutPanelLeft :size="16" strokeWidth="1.3"/>
            Editer dashboard
          </button>
        </div>
      </div>

      <div class="h-[260px] grid grid-cols-3 gap-x-[16px] mb-[16px] text-[#2b2b2b]">
        <employeCard :serie="seriesEmploye"/>
        <departementCard :nb="data?.departements" :data="departements"/>
        <div class="size-full rounded-lg border flex flex-col">
          <div class="p-[12px] grow flex flex-col justify-between font-extralight">
            <div><h2 class="flex items-center gap-x-2">Cumul Congés <Info :size="15" strokeWidth="1.3"/></h2></div>
            <div class="grow flex items-center justify-between">
              <span class="text-[32px] font-light">{{ totalConge }}</span>
              <div class="w-[70%] h-full flex flex-col justify-center">
                <div class="flex items-center gap-x-[8px]">
                  <div class="size-4 rounded-sm bg-[#ee4636]"/> 
                  <span>{{ nbRequest }}</span>
                  <span>Demandes en attentes</span>
                </div>
              </div>
            </div>
          </div>
          <button class="w-full p-3 rounded-b-lg font-extralight bg-[#f6f7fb] flex items-center justify-between">
            <span>Voir détails</span>
            <ArrowRight :size="16" strokeWidth="1.3"/>
          </button>
        </div>
      </div>

      <div class="h-[370px] grid grid-cols-2 gap-x-[16px] mb-[16px] text-[#2b2b2b]">
        <tauxAbsenteisme :serie="workload"/>
        <HrRepartition :serie="hc"/>
      </div>

      <div class="max-h-[370px] grid grid-cols-2 gap-x-[16px] mb-[16px] text-[#2b2b2b] font-extralight">
        <exceptionCard :datas="data.exceptions"/>
        <rangeAgeDonut :datas="range_age"/>
      </div>

      <div class="h-[280px] grid grid-cols-3 gap-x-[16px] text-[#2b2b2b] font-extralight">
        <contratType :serie="contrat_type"/>
        <rangeOrigin :serie="origine"/>
        <RangeSeniority :datas="range_seniority"/>
      </div>
    </template>

    <template v-else>
      <div class="animate-pulse">

        <div class="mb-[16px] flex justify-between items-center h-[36px]">
          <div class="h-full w-[230px] rounded-lg bg-gray-100"/>
            <div class="h-full w-[180px] rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[180px] grid grid-cols-3 gap-x-[16px] mb-[16px]">
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[370px] grid grid-cols-2 gap-x-[16px] mb-[16px]">
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[370px] grid grid-cols-4 gap-x-[16px] mb-[16px]">
          <div class="h-full w-full col-span-3 rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[240px] grid grid-cols-3 gap-x-[16px]">
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
import API from "../../service/API.js";
import exceptionCard from './dashboard/exception-card.vue';
import rangeAgeDonut from './dashboard/range-age-donut.vue';
import contratType from './dashboard/contrat-type.vue';
import employeCard from "./dashboard/employe-card.vue";
import { LayoutPanelLeft,ArrowRight,Info } from "lucide-vue-next";
import departementCard from "./dashboard/departement-card.vue";
import tauxAbsenteisme from "./dashboard/taux-absenteisme.vue";
import HrRepartition from "./dashboard/hr-repartition.vue";
import rangeOrigin from "./dashboard/range-origin.vue";
import RangeSeniority from "./dashboard/range-seniority.vue";
import Swal from "sweetalert2";
export default {
  name: 'DashboardView',
  components: {
    LayoutPanelLeft,
    ArrowRight,
    Info,
    tauxAbsenteisme,
    departementCard,
    employeCard,
    RangeSeniority,
    exceptionCard,
    rangeAgeDonut,
    contratType,
    HrRepartition,
    rangeOrigin
  },
  data() {
    return {
      loader: true,
      loader2: true,
      loader3: true,
      loader4: true,
      seriesEmploye:[],
      departements:{},
      origine:[],
      contrat_type:[],
      cdd:0,
      active:0,
      isLoading:true,
      cdi:0,
      stage:0,
      consultant:0,
      range_age:{},
      range_seniority:{},
      totalConge:0,
      nbRequest:0,
      mapConge : {},
      userConge:[],
      month:['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
      filter: 'w',
      other_month: [],
      otherCongeSelector:0,
      data: {},
      hc:[],
      workload:[]
    }
  },
  mounted() {
    this.loadInitialDashboardInfo()
    this.getCongeData();
    this.getotherData();
    this.getHrRepartitionAbsenteisme()
  },
  computed :{
    userName(){
      return (this.$store.getters.lastName ?? "") + " " + (this.$store.getters.firstName ?? "");
    },
    getTime(){
      return (new Date()).toDateString();
    }
  },
  methods: {
    getOtherMonth(tabs){
      this.other_month = tabs.filter((item)=> !item.is_annual);
    },
    loadInitialDashboardInfo() {
      let error_load = false;
      API.post("/getRHDashboard",{ filter: this.filter })
      .then((response)=>{
          if(response.status != 200) throw Error(response.data.message);
          this.data = response.data
      })
      .catch((error) => {
        error_load = true;
        Swal.fire('Erreur!!!!',error?.message,error.status == 403 ? 'info' : 'error')})
      .finally(()=>{
        this.loader = false || error_load;
      })
    },
    getCongeData(){
      let error_load = false;
            API.get("/getAllUsersRemainingLeaveDaysSummary")
            .then((data)=>{
                if(!data.data.status) throw Error(data.data.message);
                    this.mapConge = {...data.data.data.filter((item)=>item.is_annual == true)[0]["monthly_leave_used_global"]};
                    this.userConge = data.data["users_by_taken_days"];
                    this.totalConge = data.data.data.filter((item)=>item.is_annual == true)[0]["total_remaining_days"];
                    this.nbRequest = data.data.data.filter((item)=>item.is_annual == true)[0]["total_requests_for_annual_leave"];
                    this.getOtherMonth(data.data.data);
            })
            .catch((error) =>{
              error_load = true;
              Swal.fire('Erreur!!!!',error?.message,error.status == 403 ? 'info' : 'error')})
            .finally(()=>{
                this.loader2 = false || error_load;
            })
    },
    getHrRepartitionAbsenteisme(){
      let error_load = false;
      API.get("getChartsStatistics")
      .then((res)=>{
        if(!res.data.status) throw Error(res.data.message);
          this.hc = res.data.headcount;
          this.workload = res.data.workload;
      })
      .catch((error) =>{
        error_load = true;
        Swal.fire('Erreur!!!!',error?.message,error.status == 403 ? 'info' : 'error')})
      .finally(()=>{this.loader3 = false || error_load;})
    },
    getotherData(){
      let error_load = false;
      API.get("getFieldStatistics")
      .then((data)=>{
        if(!data.data.status) throw Error(data.data.message);
          this.seriesEmploye = [data.data.data["sexe"]["M"],data.data.data["sexe"]["F"]];
          this.departements = data.data.data["departement"];
          this.origine = [data.data.data["employee_status"]["LOCAL"],data.data.data["employee_status"]["EXPATRIÉ"]]
          this.contrat_type = [data.data.data["contract_type"]["CDI"] ?? 0,
        data.data.data["contract_type"]["CDD"] ?? 0,data.data.data["contract_type"]["STAGE"] ?? 0,data.data.data["contract_type"]["CONSULTANT"] ?? 0]
        
          this.active = data.data.data["status"]["ACTIVE"];
          this.range_age = data.data.data["age_range"];
          this.range_seniority = data.data.data["seniority_range"];
      })
      .catch((error) =>{
        error_load = true;
        Swal.fire('Erreur!!!!',error?.message,error.status == 403 ? 'info' : 'error')})
      .finally(()=>{this.loader4 = false || error_load;})
    },
    btnStatus(status) {
      return status ? "bg-[#3c41e9] text-white" : "bg-white text-[#3c41e9]";
    },
  }
}

</script>